<template>
  <div class="furniture-selector-body">
    <inline-selector
        class="furniture-selector-body__header"
        data-cy="furniture-inventory-selector"
        :selectedCategory="selectCategory"
        :items="furnitureCategory" @update:item="updateCategory"
      />
    <div :style="styleList"
         :class="['furniture-selector-body__furniture-list', {
            'loading': !init,
         }]"
         ref="furniture_list"
         data-cy="furniture-list"
    >
      <furniture-card v-for="furniture in furnitures"
                      class="furniture-selector-body__furniture-list__item"
                      :key="furniture.id"
                      :furniture="furniture"
                      :max="100"
                      :min="0"
                      :showDisassemble="disassembleEnabled"
                      @update:quantity="(qty)=>{updateFurniture(qty, furniture)}"
                      @update:disassembly="(disassembly) =>
                       {updateDisassembly(disassembly, furniture)}"
      />
      <Loader v-if="!init" :text="$t('base.loading')"/>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import FurnitureCard from './FurnitureCard.vue';
import InlineSelector from '@/components/utils/InlineSelector.vue';
import Loader from '@/components/utils/Loader.vue';


export default {
  name: 'furniture-selector-body',
  components: {
    FurnitureCard, InlineSelector, Loader,
  },
  props: {
    furnitureCategory: {
      type: Array,
      required: true,
    },
    furnitures: {
      type: Array,
      required: true,
    },
    isSearchBarOpen: {
      type: Boolean,
      default: false,
    },
    init: {
      type: Boolean,
      default: false,
    },
    selectCategory: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters({
      disassembleEnabled: 'serviceOfferStore/mount',
      height: 'dimensionStore/height',
      isMobile: 'dimensionStore/isMobile',
      isMobileWithHeight: 'dimensionStore/isMobileWithHeight',
      isDesktop: 'dimensionStore/isDesktop',
    }),
    styleList() {
      if (this.isDesktop) {
        return { height: `${this.height - 260 - 60}px` };
      }
      if (this.isMobileWithHeight) {
        return { height: `${this.height - 260 - 110 - 25}px` };
      }
      return { height: `${this.height - 240 - (this.isSearchBarOpen ? 110 : 0)}px` };
    },
  },
  methods: {
    updateCategory(event) {
      this.$emit('update:category', event);
    },
    updateFurniture(quantity, furniture) {
      this.$emit('update:furniture', { quantity, furniture });
    },
    updateDisassembly(disassembly, furniture) {
      this.$emit('update:disassembly', { disassembly, furniture });
    },
  },
};
</script>
<style scoped lang="scss">
  .action-bar{
    padding: 0;
  }

  .furniture-selector-body{
    overflow: hidden;
    &__furniture-list{
      scrollbar-width: none;
      overflow-y: scroll;
      &__item{
        margin: 4px;
      }

      @include breakpoint(mobileWithHeight){
        margin-bottom: 10px;
        display: grid;
        flex-wrap: wrap;
        align-content: baseline;
        grid-template-columns: repeat(auto-fill, 158px);
        overflow-x: hidden;
        justify-content: center;
        justify-items: center;
        padding: 0 10px;
        scrollbar-color: $--color-secondary $--color-light-grey-blue;
        scrollbar-width: thin;
      }

      @include breakpoint(wide){
        grid-template-columns: repeat(auto-fill, 258px);
      }

      &.loading {
        grid-template-columns: unset !important;
      }
    }
    &__header{
      padding: 10px 0;
      margin: 0;
      @include breakpoint(desktop){
        padding: 10px;
      }
    }
  }
</style>
